import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { SignedIn, SignedOut, useAuth } from '@clerk/clerk-react';
import '../App.css';

const API_URL = (process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3001' : '')) + '/api';

function DeleteQuestionForm({ onQuestionDeleted }) {
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [questionPool, setQuestionPool] = useState([]);
  const { getToken } = useAuth();

  useEffect(() => {
    fetchQuestionPool();
  }, []);

  const fetchQuestionPool = async () => {
    try {
      const response = await axios.get(`${API_URL}/overview`);
      setQuestionPool(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleQuestionDeletion = async () => {
    try {
      const token = await getToken();
      const response = await axios.post(`${API_URL}/deleteQuestion`, {
        question: selectedQuestion,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log(response.data); // Optioneel: toon een succesbericht

      // Reset de geselecteerde vraag
      setSelectedQuestion('');

      // Haal de bijgewerkte vraagpool opnieuw op
      fetchQuestionPool();

      // Roep de callback-functie aan om de vraagpool in FeedbackForm bij te werken
      onQuestionDeleted();
    } catch (error) {
      console.error(error);
      // Toon een foutbericht aan de gebruiker
    }
  };

  return (
    <div className="delete-question-form">
      <h1>Verwijder een vraag</h1>
      <div>
        <label className="delete-question-form-label" htmlFor="deleteQuestion">Selecteer een vraag:</label>
        <select className='delete-question-form-select'
          id="deleteQuestion"
          value={selectedQuestion}
          onChange={(e) => setSelectedQuestion(e.target.value)}
        >
          <option value="">Selecteer een vraag</option>
          {questionPool.map((question) => (
            <option key={question.id} value={question.vraag}>
              {question.vraag}
            </option>
          ))}
        </select>
      </div>
      {selectedQuestion && (
        <button onClick={handleQuestionDeletion} className="delete-question-button">
          Verwijderen
        </button>
      )}
    </div>
  );
}

function EditFeedbackForm({ onQuestionUpdated }) {
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [newQuestion, setNewQuestion] = useState('');
  const [type, setType] = useState('open');
  const [options, setOptions] = useState('');
  const [questionPool, setQuestionPool] = useState([]);
  const { getToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetchQuestionPool();
  }, []);

  const fetchQuestionPool = async () => {
    try {
      const response = await axios.get(`${API_URL}/overview`);
      setQuestionPool(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleQuestionSelection = (e) => {
    const selectedQuestion = e.target.value;
    setSelectedQuestion(selectedQuestion);
    setNewQuestion('');
    setType('');
    setOptions('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = await getToken();
      const response = await axios.post(`${API_URL}/editQuestion`, {
        question: selectedQuestion,
        newQuestion,
        type,
        options,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log(response.data); // Optioneel: toon een succesbericht

      // Reset het formulier na het bijwerken van de vraag
      setSelectedQuestion('');
      setNewQuestion('');
      setType('');
      setOptions('');

      // Haal de bijgewerkte vraagpool opnieuw op
      fetchQuestionPool();

      // Roep de callback-functie aan om de vraagpool in FeedbackForm bij te werken
      onQuestionUpdated && onQuestionUpdated();
    } catch (error) {
      console.error(error);
      // Toon een foutbericht aan de gebruiker
    }
  };

  return (
    <>
      <SignedIn>
        <div className="edit-feedback-form">
          <Link to="/" className="home-link">Home</Link>
          <div className="edit-feedback-form-container">
          <h1> Bewerk een vraag</h1>
            <label htmlFor="question" className="edit-feedback-form-label">
              Selecteer een vraag:
            </label>
            <select
              id="question"
              value={selectedQuestion}
              onChange={handleQuestionSelection}
              className="edit-feedback-form-select"
            >
              <option value="">Selecteer een vraag</option>
              {questionPool.map((question) => (
                <option key={question.id} value={question.vraag}>
                  {question.vraag}
                </option>
              ))}
            </select>
          </div>
          {selectedQuestion && (
            <form onSubmit={handleSubmit} className="edit-feedback-form-container">
              <div className="edit-feedback-form-group">
                <label htmlFor="newQuestion" className="edit-feedback-form-label">
                  Nieuwe vraag:
                </label>
                <input
                  type="text"
                  id="newQuestion"
                  value={newQuestion}
                  onChange={(e) => setNewQuestion(e.target.value)}
                  className="edit-feedback-form-input"
                />
              </div>
              <div className="edit-feedback-form-group">
                <label htmlFor="type" className="edit-feedback-form-label">
                  Type:
                </label>
                <select
                  id="type"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  className="edit-feedback-form-select"
                >
                  <option value="">Selecteer een type</option>
                  <option value="open">Open vraag</option>
                  <option value="multipleChoice">Meerkeuzevraag</option>
                </select>
              </div>
              {type === 'multipleChoice' && (
                <div className="edit-feedback-form-group">
                  <label htmlFor="options" className="edit-feedback-form-label">
                    Opties:
                  </label>
                  <input
                    type="text"
                    id="options"
                    value={options}
                    onChange={(e) => setOptions(e.target.value)}
                    className="edit-feedback-form-input"
                  />
                </div>
              )}
              <button type="submit" className="edit-feedback-form-button">
                Bewerken
              </button>
            </form>
          )}
          <DeleteQuestionForm onQuestionDeleted={fetchQuestionPool} />
        </div>
      </SignedIn>
      <SignedOut>
        <div className="main-content-wrapper">
          <div className="admin-card">
            <h2>Toegang Geweigerd</h2>
            <p>U moet ingelogd zijn om vragen te bewerken.</p>
            <button className="btn" onClick={() => navigate('/admin/login')}>Inloggen</button>
          </div>
        </div>
      </SignedOut>
    </>
  );
}

export default EditFeedbackForm;
